import { z } from 'zod';
// TODO: This is subject to change in the future
export const matchingSubscriptionTypeSchema = z.enum(['Monthly', 'Yearly']);
// The inputs each scoring factor computes its score from, and what BackOps checks a score against.
// The backend derives its own domain type from this and persists it as-is, so the two cannot drift.
//
// Durations instead of dates throughout: scorers stay pure functions of plain numbers, and the
// parameters survive jsonb persistence without Date instances silently becoming strings on read. The
// numeric boostId is fine on the wire because the only consumer is the ops tool.
export const matchingFactorParametersSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('driving-distance'), distanceInKm: z.number() }),
    z.object({ type: z.literal('days-since-last-lead'), days: z.number() }),
    z.object({
        type: z.literal('new-customer-boost'),
        contractAgeInDays: z.number(),
        subscriptionType: matchingSubscriptionTypeSchema,
    }),
    z.object({
        type: z.literal('near-contract-end'),
        contractType: z.literal('subscription'),
        subscriptionType: matchingSubscriptionTypeSchema,
        daysUntilContractEnd: z.number(),
    }),
    z.object({
        type: z.literal('near-contract-end'),
        contractType: z.literal('credit-package'),
        creditsRemaining: z.number(),
    }),
    z.object({
        type: z.literal('near-contract-end'),
        contractType: z.literal('lead-package'),
        leadsRemaining: z.number(),
    }),
    z.object({ type: z.literal('fairness-boost'), days: z.number() }),
    // Only emitted for partners with an Active boost; boostId lets the waterfall distribution record
    // usage against the right PartnerManualBoost row.
    z.object({ type: z.literal('manual-boost'), boostId: z.number().int() }),
]);
// Derived from the parameters union, so adding a factor there cannot leave this list behind.
// Deduped and order-preserving.
export const matchingFactorTypeSchema = z.enum([
    ...new Set(matchingFactorParametersSchema.options.map((option) => option.shape.type.value)),
]);
export const matchingScoreFactorSchema = z.object({
    type: matchingFactorTypeSchema,
    // Weighted factors average into the normalized 0-100 base score, additive ones are added on top.
    kind: z.enum(['weighted', 'additive']),
    // Null for a factor the partner had no parameters for: it took no part in the score, which is a
    // different statement from having scored 0.
    parameters: matchingFactorParametersSchema.nullable(),
    // The factor's own 0-100 result, before weighing.
    score: z.number().nullable(),
    // The factor's nominal share of the base score: its configured weight over the run's full weight,
    // never renormalized over the factors that happened to apply. A weighted factor that did not apply
    // keeps its share and contributes 0 points, so the shares always add up to 100%. Null for additive
    // factors, which carry no share.
    weightShare: z.number().nullable(),
    // What the factor contributed to the total score, and therefore the width of its bar segment.
    points: z.number(),
    algorithmVersion: z.string().nullable(),
});
export const partnerMatchingScoreSchema = z.object({
    // Weighted average of the weighted factors, normalized to 0-100.
    baseScore: z.number(),
    // baseScore plus every additive boost, i.e. what the waterfall ranked the partner by.
    totalScore: z.number(),
    // Every factor the run was configured with, including the ones that did not apply to this partner.
    factors: z.array(matchingScoreFactorSchema),
});
// Wrapped rather than returned bare, because Nest serializes a bare null as an empty body. Null covers
// both a partner that was never scored and a matching predating the scoring algorithm.
export const partnerMatchingScoreResponseSchema = z.object({
    score: partnerMatchingScoreSchema.nullable(),
});
